import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PropType } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'InstructionsModal',
  props: {
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleInstructionsModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
},
  setup(__props) {



const instructions = useTasksStore().activeTask?.description;

return (_ctx: any,_cache: any) => {
  return (__props.showModal)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: __props.toggleInstructionsModal
      }, {
        header: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode(" Instructions ")
        ])),
        main: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(_unref(instructions)), 1)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.toggleInstructionsModal && __props.toggleInstructionsModal(...args))),
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Close ")
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}
}

})